import { render } from "./PersonalInfor.vue?vue&type=template&id=96a2b35a&ts=true"
import script from "./PersonalInfor.vue?vue&type=script&lang=ts"
export * from "./PersonalInfor.vue?vue&type=script&lang=ts"

import "./PersonalInfor.vue?vue&type=style&index=0&id=96a2b35a&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__